var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var SvgExternal = function SvgExternal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['svgRef', 'title']);

  return React.createElement('svg', _extends({
    viewBox: '0 0 12 12',
    ref: svgRef
  }, _extends({
    width: '1em',
    height: '1em'
  }, props)), React.createElement('title', null, title), React.createElement('defs', null, React.createElement('path', {
    id: 'External_svg_a',
    d: 'M1243.667 589.667h-9.334v-9.334H1239V579h-4.667c-.74 0-1.333.6-1.333 1.333v9.334c0 .733.593 1.333 1.333 1.333h9.334c.733 0 1.333-.6 1.333-1.333V585h-1.333zM1240.333 579v1.333h2.394l-6.554 6.554.94.94 6.554-6.554v2.394H1245V579z'
  })), React.createElement('use', {
    fill: 'currentColor',
    xlinkHref: '#External_svg_a',
    transform: 'translate(-1233 -579)'
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExternal, _extends({
    svgRef: ref
  }, props));
});
export default ForwardRef;